import { useState } from 'react'
import { Modal, ModalBody } from 'components/modal'
import { Form, FormButtonGroup } from 'components/forms'

const RemoveCollaboratorModal = ({
  show,
  onHide,
  onSubmit,
  collaborator: { firstName, email },
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = (e) => {
    setIsSubmitting(true)
    e.preventDefault()
    onSubmit().then(onSuccess)
  }

  const onSuccess = () => {
    onHide()
    setIsSubmitting(false)
  }

  return (
    <Modal onHide={onHide} show={show} title="Remove Collaborator">
      <ModalBody>
        <Form onSubmit={handleSubmit}>
          <p className="pbl">
            Are you sure you want to remove{' '}
            <strong>{firstName || email}</strong>?
            <br />
            <strong>{firstName || email}</strong> will no longer be able to add
            or remove items on your baby registry.
          </p>
          <FormButtonGroup
            onClickSecondary={onHide}
            submitting={isSubmitting}
            textPrimary="Remove Collaborator"
            textSecondary="Cancel"
          />
        </Form>
      </ModalBody>
    </Modal>
  )
}

export default RemoveCollaboratorModal
